/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
module.exports = {
	types: {
		QoS: [{
			value: 0,
			description: 'At most once',
		}, {
			value: 1,
			description: 'At least once.',
		}, {
			value: 2,
			description: 'Exactly once.',
		}],
		FileMode: [{
			value: 'append',
			description: 'Append to exiting file.',
		}, {
			value: 'create',
			description: 'Create new  file.',
		}]
	},
	functions: {
		/* 'KAFKA.COMMAND': {
			default: {
				category: 'Connection',
				description: 'Allows KSQL commands to be used.',
				inlineDescription: 'Allows KSQL commands to be used.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Producer to use.',
						optional: false
					},
					{
						type: 'String',
						name: 'Command',
						description: 'Any command allowed in KSQL table.',
						optional: false
					},
					{
						type: 'Target',
						name: 'Target',
						description: 'INBOX(), OUTBOX("MsgID") or a cell range where the result will be placed. Make sure the cell range is big enough or not everything is displayed.',
						optional: false
					},
					{
						type: 'Number',
						name: 'Timeout',
						description: 'A period in seconds to wait for an answer.',
						default: 20,
						optional: true
					}
				],
				return: {
					type: 'Boolean',
					description: 'TRUE, if no [error]($HelpLink$/other/errorcodes).'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=KAFKA.COMMAND(&#124;KafkaProducer, "CREATE TABLE ksqltable201 (random BIGINT, type VARCHAR) WITH (kafka_topic=\'cedalo\', value_format=\'JSON\', key = \'random\')", INBOX ())',
							result: 'TRUE',
							comment: 'A KSQL table will be created with the name ksqltable201.'
						}
					]
				}
			}
		},
		'KAFKA.PUBLISH': {
			default: {
				category: 'Connection',
				description: 'Publishes either a message or an arbitrary value using a specified Producer and topic. To reference a message from the outbox use the outbox function and to reference a message from the inbox use INBOX. ',
				inlineDescription: 'Publishes either a message or an arbitrary value using a specified Producer and topic.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Producer to use for publishing.',
						optional: false
					},
					{
						type: 'String',
						name: 'Message',
						description: 'Either an existing message from the outbox a JSON or a primitive value to publish.',
						optional: false
					},
					{
						type: 'String',
						name: 'Topic',
						description: 'Topic the message is published to.',
						optional: false
					}
				],
				return: {
					type: 'Boolean or Error',
					description: 'TRUE, if no [error]($HelpLink$/other/errorcodes).'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=KAFKA.PUBLISH(&#124;Kafka Producer,"Message","test")',
							result: 'TRUE',
							comment: 'This publishes the string value "Message" using the "Kafka Producer" to the topic "test"'
						}
					]
				}
			}
		},
		'KAFKA.QUERY': {
			default: {
				category: 'Connection',
				description: 'Allows KSQL queries to be used. ',
				inlineDescription: 'Allows KSQL queries to be used. ',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Producer to use.',
						optional: false
					},
					{
						type: 'String',
						name: 'Query',
						description: 'Any query allowed on a KSQL table.',
						optional: false
					},
					{
						type: 'Target',
						name: 'Target',
						description: 'INBOX(), OUTBOX("MsgID") or a cell range where the result will be placed. Make sure the cell range is big enough or not everything is displayed.',
						optional: false
					},
					{
						type: 'Number',
						name: 'Timeout',
						description: 'A period in seconds to wait for an answer.',
						default: 20,
						optional: true
					}
				],
				return: {
					type: 'Boolean or Error',
					description: 'TRUE, if no [error]($HelpLink$/other/errorcodes).'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=KAFKA.Query(&#124;Kafka Producer, "select * from ksqltable200", INBOX())',
							result: 'TRUE',
							comment: 'The complete data from ksqltable200 will be shown in the inbox.'
						}
					]
				}
			}
		},*/
	}};
